import { createFileRoute } from '@tanstack/react-router';

import { GraphicsGallery } from '~/features/dev/graphics-gallery';

/** Every Skia graphic, with sample data. A developer page, open to anyone. */
export const Route = createFileRoute('/dev/graphics')({ component: GraphicsGallery });
